/** @jsxImportSource @emotion/react */
import { css } from "@emotion/react";
import styled from "@emotion/styled";
import React from "react";
import { ReactComponent as NoFeeIcon } from "../../../../img/approval_svgs/permit/NoFees.svg";
import { ReactComponent as SecurityIcon } from "../../../../img/approval_svgs/permit/Security.svg";
import { withIsVisible } from "../../../../utils/reactUtils";
import { Text } from "../../../general/Text";

const SignatureBenefitsSection: React.FC = () => {
  return (
    <div
      css={css`
        display: flex;
        align-items: center;
        margin: 20px auto 12px;
        gap: 10px;
        max-width: 385px;
        border-radius: 18px;
        height: 94px;
      `}
    >
      <CentralDivWrapper>
        <NoFeeIcon
          css={css`
            margin-bottom: 5px;
          `}
        />
        <Text textStyle="Paragraph" size="Medium" shouldScale={false}>
          Save on fees and never pay for permissions again
        </Text>
      </CentralDivWrapper>
      <CentralDivWrapper>
        <SecurityIcon
          css={css`
            margin-bottom: 5px;
          `}
        />
        <Text textStyle="Paragraph" size="Medium" shouldScale={false}>
          Industry standard and secure, so your funds are safe
        </Text>
      </CentralDivWrapper>
    </div>
  );
};
const CentralDivWrapper = styled.div`
  text-align: center;
  padding-left: 15px;
  padding-right: 15px;
`;

export default withIsVisible(SignatureBenefitsSection);
